import { Avatar, Badge, Checkbox, Col, Row, Typography } from 'antd';
import { CheckboxChangeEvent } from 'antd/lib/checkbox';
import moment from 'moment';
import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import API from '../../../api/API';
import { UserContext } from '../../../contexts';
import { INotification } from '../../../models/notification';
import './NotificationPill.less';

const { Text } = Typography;

interface IProps {
  notification: INotification;
  onChange: (e: CheckboxChangeEvent, notification: INotification) => void;
}

const NotificationPill: React.FC<IProps> = (props: IProps) => {
  const { user } = useContext(UserContext);
  const { notification, onChange } = props;
  const history = useHistory();

  const getInitials = (createdBy: string) => {
    const names = createdBy.split('.', 2);
    let initials = '';

    names.forEach((name) => {
      initials += name.charAt(0).toUpperCase();
    });

    return initials;
  };

  const getMessage = (createdBy: string, message: string) => {
    const splitMessage = message.substr(createdBy.length);

    return splitMessage;
  };

  const onNotificationClick = () => {
    API.put(`/notification/${user.username}`, null, {
      params: { ids: [notification.id] },
    });
    history.push(`events/${notification.action.eventId}`);
  };

  return (
    <Row gutter={16} align="middle" className="mt-1">
      <Col>
        <Checkbox onChange={(e) => onChange(e, notification)} />
      </Col>
      <Col span={16} onClick={onNotificationClick}>
        <Row align="middle" className="NotificationPill-body">
          <Col style={{ marginRight: '1em' }}>
            <Badge
              status={notification.read ? 'default' : 'success'}
              offset={[-65, 10]}
            >
              <Avatar size={80}>{getInitials(notification.createdBy)}</Avatar>
            </Badge>
          </Col>
          <Col span={20}>
            <Text strong>{notification.createdBy}</Text>
            <Text>
              {' '}
              {getMessage(notification.createdBy, notification.message)}
            </Text>
            <Row>
              <Text type="secondary">
                {moment(notification.createdOn).fromNow()}
              </Text>
            </Row>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default NotificationPill;
